import anime from 'animejs'

/**
 * Animation helpers required for interactions on mobile version of the people page feature.
 * Utilises FLIP animation technique to implement shared element transitions.
 */

/**
 * Given list item element, query all required elements and return as one object
 * @param {Element} itemEl
 * @returns {Object}
 */
const getAnimationEls = (itemEl) => {
  return {
    thumb: itemEl.querySelector('.js-profile-thumb'),
    tileDivider: itemEl.querySelector('.js-tile-divider'),
    labels: itemEl.querySelector('.js-profile-labels'),
    profile: itemEl.querySelector('.js-mobile-profile'),
    image: itemEl.querySelector('.js-profile-image'),
    closeBtn: itemEl.querySelector('.js-close-profile-btn'),
    profileDivider: itemEl.querySelector('.js-profile-divider'),
    profileBody: itemEl.querySelector('.js-profile-body'),
  }
}

/**
 * Applies animation to transition from list item view to profile view
 * @param {Element} itemEl
 */
export const expandMobileProfile = (itemEl) => {
  const target = getAnimationEls(itemEl)

  // Calculate inverted image animation properties
  const itemHeightFirst = itemEl.getBoundingClientRect()
  const imageElFirst = target.thumb.getBoundingClientRect()
  itemEl.classList.add('c-profile-list__item--active')
  const itemHeightLast = itemEl.getBoundingClientRect()
  const imageElLast = target.image.getBoundingClientRect()

  const invertedDeltaX = -(imageElLast.x - imageElFirst.x)
  const invertedDeltaY = -(imageElLast.y - imageElFirst.y)

  const invertedImageH = imageElFirst.height / imageElLast.height
  const invertedImageW = imageElFirst.width / imageElLast.width

  const timeline = anime.timeline({
    easing: 'cubicBezier(0.22, 1, 0.36, 1)',
    complete: () => {
      itemEl.style.height = 'auto'
    },
  })

  timeline
    .add({
      targets: itemEl,
      duration: 250,
      height: [`${itemHeightFirst.height}px`, `${itemHeightLast.height}px`],
    })
    .add(
      {
        targets: target.image,
        duration: 250,
        translateX: [`${invertedDeltaX}px`, 0],
        translateY: [`${invertedDeltaY}px`, 0],
        scaleX: [`${invertedImageW}`, 1],
        scaleY: [`${invertedImageH}`, 1],
      },
      0,
    )
    .add({
      targets: target.profileBody,
      duration: 400,
      opacity: [0, 1],
    })
    .add(
      {
        targets: target.closeBtn,
        duration: 400,
        opacity: [0, 1],
      },
      '-=400',
    )
}

/**
 * Applies animation to transition from profile view to list item view
 * @param {Element} itemEl
 */
export const contractMobileProfile = (itemEl) => {
  const target = getAnimationEls(itemEl)

  // Calculate inverted image animation properties
  const itemHeightFirst = itemEl.getBoundingClientRect()
  const imageElFirst = target.image.getBoundingClientRect()
  itemEl.classList.remove('c-profile-list__item--active')
  const itemHeightLast = itemEl.getBoundingClientRect()
  const imageElLast = target.thumb.getBoundingClientRect()

  const invertedDeltaX = -(imageElLast.x - imageElFirst.x)
  const invertedDeltaY = -(imageElLast.y - imageElFirst.y)

  const invertedImageH = imageElFirst.height / imageElLast.height
  const invertedImageW = imageElFirst.width / imageElLast.width

  const timeline = anime.timeline({
    easing: 'cubicBezier(0.22, 1, 0.36, 1)',
    complete: () => {
      itemEl.style.height = 'auto'
      target.thumb.style = ''
    },
  })

  timeline
    .add({
      targets: itemEl,
      duration: 250,
      height: [`${itemHeightFirst.height}px`, `${itemHeightLast.height}px`],
    })
    .add(
      {
        targets: target.thumb,
        duration: 250,
        translateX: [`${invertedDeltaX}px`, 0],
        translateY: [`${invertedDeltaY}px`, 0],
        scaleX: [`${invertedImageW}`, 1],
        scaleY: [`${invertedImageH}`, 1],
      },
      0,
    )
}
